import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Theme from "../../vars/ThemeOptions";
import { R } from "../common/";

const Styled = {};
Styled.H3 = styled.h3`
  text-align: center;
  &.white {
    color: ${Theme.hex("white")};
  }
  &.left {
    display: block;
    text-align: left;
    max-width: 786px;
    line-height: 1;
    padding-bottom: 0.75rem;
    border-bottom: 1px solid ${Theme.hex("blue")};
    margin: auto;
    margin-bottom: 1rem;
    margin-top: 1rem;
  }
`;

export const H3 = ({ children, white, topic }) => {
  const _classname = white ? ["white"] : ["black"];
  _classname.push("thr-h3");
  if (topic) _classname.push("left");
  return (
    <Styled.H3 className={_classname.join(" ")}>
      <R>{children}</R>
    </Styled.H3>
  );
};

H3.defaultProps = {
  white: false,
};

H3.propTypes = {
  children: PropTypes.node.isRequired,
  white: PropTypes.bool,
};
